import React from 'react';

import logo from '../assets/logo.png';

const Logo = ({ handleChangePage }) => {
    return <img className='header-logo' onClick={() => handleChangePage('/')} src={logo} alt='logo' />;
};

export default Logo;
